<template>
  <v-card :loading="loading">
    <v-toolbar color="grey lighten-4" light tile flat>
      <v-toolbar-title centered class="headline font-weight-bold">
        Configuration settings
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn color="primary" tile @click="isAdding = true">
        <v-icon>mdi-plus</v-icon>
        New Setting
      </v-btn>
      <v-dialog v-model="isAdding" title="Add a transaction" width="500px">
        <v-card>
          <v-card-title class="primary white--text d-flex justify-space-between">
            <span>Add a new configuration</span>
            <v-btn text icon dark @click="isAdding = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-container>
            <create-config-form @configAdded="configAdded" />
          </v-container>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-container>
      <v-card-text>
        <v-row class="text-capitalize">
          <v-col cols="6" md="6" v-for="(item, index) in configurations" :key="index">
            <v-text-field
              v-model="values[index]"
              :label="item.key"
              :ref="item.key"
              :rules="commonRules"
              required
            >
              <v-btn slot="append-outer" color="primary" @click="updateConfig(item.key, index)"
                >Update</v-btn
              ></v-text-field
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-container>
  </v-card>
</template>
<script>
import CreateConfigForm from "./createConfigForm";

export default {
  components: { CreateConfigForm },
  data() {
    return {
      configurations: [],
      values: [],
      configValue: "",
      url: "api/v1/config",
      loading: false,
      isAdding: false,
      commonRules: [(v) => !!v || "This field is required"],
    };
  },
  created() {
    this.fetchConfigurations();
  },
  methods: {
    fetchConfigurations() {
      this.loading = true;
      // initiate transaction
      return this.$http
        .get(this.url)
        .then((response) => {
          this.loading = false;
          this.configurations = response;
          //   add the configurations to the model
          this.configurations.forEach((config, index) => {
            this.values[index] = config.value;
          });
        })
        .catch((error) => {
          this.loading = false;
          Notify.errorFromResponse(error, { close: true });
        });
    },
    updateConfig(key, index) {
      // validate the field
      if (!this.$refs[key][0].validate()) {
        Notify.error("Config value should not be empty.");
        return;
      }
      const data = { value: this.values[index] };
      return this.$http
        .put(`${this.url}/${key}`, { ...data })
        .then((response) => {
          this.loading = false;
          window.Notify.success(response.message);
          this.fetchConfigurations();
        })
        .catch((error) => {
          this.loading = false;
          Notify.errorFromResponse(error, { close: true });
        });
    },
    configAdded() {
      this.isAdding = false;
      this.fetchConfigurations();
    },
  },
};
</script>
